import { Department } from "../models";

// string to upper case first letter
const upperCaseFirstLetter = (string) => {
  return string.charAt(0).toUpperCase() + string.slice(1);
};
var CUSTOMEPOCH = 1300000000000; // artificial epoch
export const generateRowId = (shardId = 2 /* range 0-64 for shard/slot */) => {
  var ts = new Date().getTime() - CUSTOMEPOCH; // limit to recent
  var randid = Math.floor(Math.random() * 512);
  ts = ts * 64; // bit-shift << 6
  ts = ts + shardId;
  return ts * 512 + (randid % 512);
};
export const createUniqueCode = (number) => {
  const base36Chars = "0123456789abcdefghijklmnopqrstuvwxyz";
  let code = "";

  while (number > 0 && code.length < 8) {
    const remainder = number % 36;
    code = base36Chars[remainder] + code;
    number = Math.floor(number / 36);
  }

  return code.slice(-8);
};
const mapDepartmentWithIcon = (department, AppAssets) => {
  if (department == Department.HUMAN_RESOURCES) return AppAssets?.icons?.users;
  else if (department == Department.FINANCE_AND_ACCOUNTING)
    return AppAssets?.icons?.invoice;
  else if (department == Department.SALES) return AppAssets?.icons?.sales;
  else if (department == Department.MARKETING)
    return AppAssets?.icons?.marketing;
  else if (department == Department.OPERATIONS)
    return AppAssets?.icons?.operations;
  else if (department == Department.INFORMATION_TECHNOLOGY)
    return AppAssets?.icons?.parser;
  else if (department == Department.CUSTOMER_SERVICE)
    return AppAssets?.icons?.customerService;
  else if (department == Department.RESEARCH_AND_DEVELOPMENT)
    return AppAssets?.icons?.research;
  else if (department == Department.LEGAL_AND_COMPLIANCE)
    return AppAssets?.icons?.legal;
  else if (department == Department.SUPPLY_CHAIN_MANAGEMENT)
    return AppAssets?.icons?.supplyChain;
  else if (department == Department.PROJECT_MANAGEMENT)
    return AppAssets?.icons?.project;
  else return AppAssets?.icons?.genericDepartment;
  // else if (department == Department.QUALITY_ASSURANCE)
  //   return AppAssets?.icons?.qualityAssurance;
  // else if (department == Department.PROCUREMENT)
  //   return AppAssets?.icons?.procurement;
  // else if (department == Department.BUSINESS_DEVELOPMENT)
  //   return AppAssets?.icons?.businessDevelopment;
  // else if (department == Department.PUBLIC_RELATIONS)
  //   return AppAssets?.icons?.publicRelations;
  // else if (department == Department.PRODUCT_MANAGEMENT)
  //   return AppAssets?.icons?.productManagement;
  // else if (department == Department.FACILITIES_MANAGEMENT)
  //   return AppAssets?.icons?.facilitiesManagement;
  // else if (department == Department.RISK_MANAGEMENT)
  //   return AppAssets?.icons?.riskManagement;
  // else if (department == Department.TRAINING_AND_DEVELOPMENT)
  //   return AppAssets?.icons?.training;
  // else if (department == Department.HEALTH_AND_SAFETY)
  //   return AppAssets?.icons?.healthAndSafety;
  // else if (department == Department.CORPORATE_STRATEGY)
  //   return AppAssets?.icons?.corporateStrategy;
  // else if (
  //   department == Department.SUSTAINABILITY_AND_CORPORATE_SOCIAL_RESPONSIBILITY
  // )
  //   return AppAssets?.icons?.sustainability;
  // else if (department == Department.DATA_ANALYTICS)
  //   return AppAssets?.icons?.dataAnalytics;
  // else if (department == Department.DIGITAL_TRANSFORMATION)
  //   return AppAssets?.icons?.digitalTransformation;
  // else if (department == Department.INNOVATION_MANAGEMENT)
  //   return AppAssets?.icons?.innovationManagement;
  // else if (department == Department.CYBERSECURITY)
  //   return AppAssets?.icons?.cybersecurity;
  // else if (department == Department.TALENT_ACQUISITION)
  //   return AppAssets?.icons?.talentAcquisition;
  // else if (department == Department.CHANGE_MANAGEMENT)
  //   return AppAssets?.icons?.changeManagement;
  // else if (department == Department.KNOWLEDGE_MANAGEMENT)
  //   return AppAssets?.icons?.knowledgeManagement;
  // else if (department == Department.DIVERSITY_AND_INCLUSION)
  //   return AppAssets?.icons?.diversityAndInclusion;
  // else if (department == Department.ENVIRONMENTAL_MANAGEMENT)
  //   return AppAssets?.icons?.environmentalManagement;
  // else if (department == Department.CRISIS_MANAGEMENT)
  //   return AppAssets?.icons?.crisisManagement;
  // else return AppAssets?.icons?.department;
};

const mapAgentTypeWithIcon = (agent, AppAssets) => {
  if (agent?.agentType == "BusinessAnalyst")
    return AppAssets?.icons?.businessAnalyst;
  else if (agent?.agentType == "ContentCreator")
    return AppAssets?.icons?.contentCreator;
  else if (agent?.mode == "planner") return AppAssets?.icons?.planner;
  else if (agent?.mode == "chatter") return AppAssets?.icons?.casual;
  else if (agent?.mode == "coder") return AppAssets?.icons?.coder;
  else if (agent?.mode == "computer") return AppAssets?.icons?.computerUser;
  else if (agent?.mode == "voice") return AppAssets?.icons?.voiceUser;
  else return AppAssets?.icons?.agent;
};
const mapAgentTypeWithLabel = (agent) => {
  if (agent?.agentType == "BusinessAnalyst") return "Operator";
  else if (agent?.agentType == "ContentCreator") return "Operator";
  else if (agent?.mode == "planner") return "Orchestrator";
  else if (agent?.mode == "chatter") return "Assistant";
  else if (agent?.mode == "coder") return "Programmer";
  else if (agent?.mode == "computer") return "Desktop";
  else if (agent?.mode == "voice") return "Voice";
  else return "Operator";
};
function camelCaseToSpaced(str) {
  // Use regular expression to match camel case words
  const regex = /([a-z0-9])([A-Z0-9])/g;
  // Replace camel case words with spaces, lowercase the first letter of the second word, and capitalize the very first letter
  return str
    .replace(regex, (match, $1, $2) => `${$1} ${$2.toLowerCase()}`)
    .replace(/^[a-z]/, (match) => match.toUpperCase());
}
function purifySlateObject(input) {
  return input.map((entry) => {
    if (entry.type === "ul_list") {
      return {
        ...entry,
        children: entry.children.map((listItem) => {
          if (
            listItem.type === "list_item" &&
            listItem.children[0].type === "paragraph"
          ) {
            const newParagraphChildren = listItem.children[0].children.map(
              (item) => {
                if (item.type === "link") {
                  // Transform the link structure
                  return {
                    type: "link",
                    url: item.link,
                    text: item.children[0].text,
                  };
                }
                return item; // Return other items unchanged
              },
            );
            return {
              ...listItem,
              children: [
                {
                  type: "paragraph",
                  children: newParagraphChildren,
                },
              ],
            };
          }
          return listItem;
        }),
      };
    }
    return entry;
  });
}
const mapFunctionTypeToColour = (fn, currentTheme) => {
  if (fn?.isChatFn) return currentTheme?.theme?.green;
  else if (fn?.isAgentSkill) return currentTheme?.theme?.teal;
  else if (fn?.isHtmlFn) return currentTheme?.theme?.purple;
  else if (fn?.isDatabaseScript) return currentTheme?.theme?.orange;
  else return currentTheme?.theme?.primary;
};

const mapFunctionTypeToLabel = (fn) => {
  if (fn?.isChatFn) return "chat";
  else if (fn?.isAgentSkill) return "skill";
  else if (fn?.isHtmlFn) return "html";
  else if (fn?.isDatabaseScript) return "db";
  else if (fn?.isCodeTemplate) return "code";
  else if (fn?.isMCPServer) return "mcp";
  else return "api";
};

const mapFunctionTypeToIcon = (fn, AppAssets) => {
  if (fn?.isChatFn) return AppAssets?.icons?.chatIcon;
  else if (fn?.isAgentSkill) return AppAssets?.icons?.skill;
  else if (fn?.isHtmlFn) return AppAssets?.icons?.html;
  else if (fn?.isDatabaseScript) return AppAssets?.icons?.data;
  else if (fn?.isCodeTemplate) return AppAssets?.icons?.code;
  else if (fn?.isMCPServer) return AppAssets?.icons?.mcp;
  else return AppAssets?.icons?.api;
};

const mapAgentTypeToColour = (agent, currentTheme) => {
  if (agent?.agentType == "Chatbot") return currentTheme?.primary;
  else if (agent?.agentType == "BusinessAnalyst") return currentTheme?.orange;
  else if (agent?.agentType == "ContentCreator") return currentTheme?.green;
  else return currentTheme?.primary;
};
export default {
  upperCaseFirstLetter,
  generateRowId,
  createUniqueCode,
  purifySlateObject,
  camelCaseToSpaced,
  mapFunctionTypeToColour,
  mapFunctionTypeToLabel,
  mapFunctionTypeToIcon,
  mapAgentTypeToColour,
  mapAgentTypeWithIcon,
  mapDepartmentWithIcon,
  mapAgentTypeWithLabel,
};
